export default "__VITE_PUBLIC_ASSET__86e1bccf__"